'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PublishButton = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _reactImmutableProptypes = require('react-immutable-proptypes');

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _baseButtons = require('@bibliocommons/base-buttons');

var _baseIcons = require('@bibliocommons/base-icons');

var _utilsList = require('@bibliocommons/utils-list');

var _constantsList = require('@bibliocommons/constants-list');

require('../styles/PublishButton.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  handleClick: _react2.default.PropTypes.func,
  list: _bcPropTypes.listShape.isRequired,
  items: _reactImmutableProptypes2.default.listOf(_bcPropTypes.listItemShape).isRequired,
  listHasUnsavedChanges: _react2.default.PropTypes.bool.isRequired,
  savingDraft: _react2.default.PropTypes.bool.isRequired,
  publishing: _react2.default.PropTypes.bool.isRequired,
  editingAnchorBib: _react2.default.PropTypes.bool.isRequired
};

var PublishButton = exports.PublishButton = function (_BcReactComponent) {
  _inherits(PublishButton, _BcReactComponent);

  function PublishButton(props) {
    _classCallCheck(this, PublishButton);

    var _this = _possibleConstructorReturn(this, (PublishButton.__proto__ || Object.getPrototypeOf(PublishButton)).call(this, props));

    _this.bindAll('canPublish', 'renderMessage');
    return _this;
  }

  _createClass(PublishButton, [{
    key: 'canPublish',
    value: function canPublish() {
      var _props = this.props,
          publishing = _props.publishing,
          editingAnchorBib = _props.editingAnchorBib,
          items = _props.items,
          list = _props.list;

      var hasFourOrMoreItems = items.size >= 4;
      var doesNotExceedMax = items.size <= _constantsList.MAX_LIST_ITEMS;
      return !publishing && !editingAnchorBib && hasFourOrMoreItems && doesNotExceedMax && list.get('name');
    }
  }, {
    key: 'renderMessage',
    value: function renderMessage() {
      var list = this.props.list;


      if ((0, _utilsList.isStaffOnlyList)(list)) {
        return _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'user_list_publish' });
      }

      return _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'user_list_finished_editing' });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          handleClick = _props2.handleClick,
          publishing = _props2.publishing;


      return _react2.default.createElement(
        _baseButtons.Button,
        {
          className: 'cp-user-list-publish-button save-btn btn-primary',
          disabled: !this.canPublish(),
          handleClick: handleClick,
          'data-test-id': 'publish-button' },
        publishing ? _react2.default.createElement(_baseIcons.Spinner, { color: '#FFF' }) : null,
        _react2.default.createElement(
          'span',
          { className: 'text' },
          this.renderMessage()
        )
      );
    }
  }]);

  return PublishButton;
}(_baseBcReactComponent2.default);

PublishButton.propTypes = propTypes;

exports.default = PublishButton;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/publish-button/components/PublishButton.component.js
// module id = 1328
// module chunks = 0